import { render, staticRenderFns } from "./MyAddresses.vue?vue&type=template&id=186f967f&scoped=true&"
import script from "./MyAddresses.vue?vue&type=script&lang=js&"
export * from "./MyAddresses.vue?vue&type=script&lang=js&"
import style0 from "./MyAddresses.vue?vue&type=style&index=0&id=186f967f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186f967f",
  null
  
)

export default component.exports